module.exports = __webpack_public_path__ + "static/img/Meal_record.b6741a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/Meal_record.png
// module id = Q/0V
// module chunks = 1